import { z } from 'zod'

export const AuthTokensShort = z.object({
    access: z.string().min(1),
    refresh: z.string().min(1),
})

export type AuthTokensShort = z.infer<typeof AuthTokensShort>

export const AuthTokens = z.object({
    access_token: z.string().min(1),
    refresh_token: z.string().min(1),
})

export type AuthTokens = z.infer<typeof AuthTokens>
